<template>
    <div class="operationslevelone">
        <PageTitle icon="fa fa-clone" main="Record" sub="Operation" />
        <b-container fluid class="text-dark text-center">
        <b-row align-h="start">
             <b-col md="2" sm="12" >
                <transition  
                    name="slide" 
                    type="animation" 
                    appear>          
                    <b-table 
                        stacked  
                        small 
                        class="table-responsive" 
                        hover 
                        head-variant="light" 
                        bordered
                        key="slide"  
                        :items="operations" 
                        :fields="fieldsOperation">
                    <template v-slot:cell(actions)="data">
                            <b-button 
                                title = "Operation" 
                                size="sm" 
                                variant="light" 
                                @click="setOperations(data.item)" 
                                class="mr-2 mt-2">
                                <i class="fa fa-drivers-license-o"></i>
                            </b-button>
                            <b-button  
                                v-b-modal.modalOperationOne  
                                title = "Add Category" 
                                size="sm" 
                                variant="light" 
                                @click="setOperations(data.item)" 
                                class="mr-2 mt-2">
                                    <i class="fa fa-plus"></i>
                            </b-button>
                        </template>   
                    </b-table>    
                </transition>
                </b-col>
            <b-col  md="4" sm="12" >
                <transition  name="slide" type="animation" appear>          
                <b-table 
                    head-variant="light"   
                    class="table-responsive" 
                    v-show="showTable" 
                    hover 
                    key="slide" 
                    :per-page="perPage" 
                        :current-page="currentPageOne" 
                    :items="operationslevelones" 
                    :fields="fieldsOperationsLevelOne">
                <template v-slot:cell(actions)="data">
                    <b-button 
                         size="sm" 
                         v-b-modal.modalOperationOne 
                         variant="light" 
                         @click="loadOperationsLevelOne(data.item)" 
                         class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                        <b-button  
                            size="sm" 
                            variant="light" 
                            @click="modeOperOne = 'remove'" 
                            class="mr-2 mt-2"
                            v-if="modeOperOne === 'insert'"
                        >
                            <i class="fa fa-trash"></i>
                        </b-button>
                        <b-button 
                             size="sm" 
                             variant="light" 
                             @click="[removeOperationsLevelOne(data.item),modeOperOne = 'insert']" 
                             class="mr-2 mt-2"
                            v-if="modeOperOne === 'remove'"
                        >
                            <i class="fa fa-check"></i>
                        </b-button>
                        <b-button 
                             size="sm" 
                             variant="light" 
                             @click="modeOperOne = 'insert'" 
                             class="mr-2 mt-2"
                            v-if="modeOperOne === 'remove'"
                        >
                            <i class="fa fa-times"></i>
                        </b-button>
                        <span 
                            class="mr-2 mt-2"  
                            v-if="modeOperOne === 'remove'" >Do you want to delete the record?</span>
                       
                     </template>   
                    </b-table>   
                    
                    </transition>
                    <b-pagination
                    v-show="showTable"
                    v-model="currentPageOne"
                    :total-rows="rowsOne"
                    :per-page="perPage"
                    aria-controls="my-table"
                ></b-pagination> 
                </b-col>
               
        </b-row>
     
          
        </b-container>
        
        <b-modal id="modalOperationOne"
            ref="modal"
            title-tag = "h6"
            title="Category"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveOperationOne"
            >
           <b-form>
               <b-row>
                   <b-col md="12" sm="12">
                        <b-form-group 
                            label="Description:" 
                            label-for="operationslevelone-name_operation_level_one">
                            <b-form-input 
                                id="operationslevelone-name_operation_level_one" 
                                type="text"
                                v-model="operationslevelone.name_operation_level_one" 
                                size="sm"
                                placeholder="Description..." />
                        </b-form-group>
                    </b-col>
                   
               </b-row>
               <b-row>
                 <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="operationslevelone.blocked" true-value="1" false-value="0" 
                                    type="checkbox" 
                                    id="operationslevelone-blocked"
                                >
                                <label class="form-check-label" for="operationslevelone-blocked">
                                    Blocked?
                                </label>
                            </div>
                        </div>
                    </b-col>  
               </b-row>
           </b-form>

        </b-modal>
  
    </div>
</template>

<script>

import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from "../template/PageTitle"
var moment = require('moment')

export default {
    name: 'OperationsLevelOne',
    components: { PageTitle},
    data: function() {
        return {
            mode: 'insert',
            modeOperOne: 'insert',
            modeOperTwo: 'insert',
            modeOperGroup: 'insert',
            modeParameter: 'insert',
            search: '',
            operationsleveltwo: {},
            operationsleveltwos: [],
            operationslevelone: {},
            operationslevelones: [],
            operationstypegroupcostrecipe: {},
            operationstypegroupcostrecipes:[],
            operations: [],
            operation: {},
            typecosts: [],
            taxregimeoptings: [],
            operationsparameteroperation: {},
            operationsparameteroperations: [],
            parameterdetailoperations: [],
            typegroupcostrecipes: [],
            accountplans: [],
            historicalstandards: [],
            showTable: false,
            showTableTwo: false,
            showTableTypeGroup: false,
            isBusy: false,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            perPage: 20,
            currentPageOne: 1,
            currentPageTwo: 1,
            fieldsOperation: [
                { key: 'name_operation', label: '', sortable: true ,variant: 'light'},
                { key: 'actions', label: '' }
            ],
            fieldsOperationsLevelOne: [
                { key: 'name_operation_level_one', label: 'Category', sortable: true ,variant: 'light'},
                { key: 'actions', label: 'Action' , variant: 'light'}
            ]
        }
    },
     computed: {
        user(){
            return this.$store.state.user
        },
        compan(){
                return this.$store.state.compan
            },
        rowsOne() {
            return this.operationslevelones.length
        },
        rowsTwo() {
            return this.operationsleveltwos.length
        }
    },
    
    methods: {
        formatDateTime(date) {
                return moment.utc(date).format('YYYY-MM-DD hh:mm')
            },
       async loadOperationsLevelOnes() {
            const url = `${baseApiUrl}/operationslevelones/${this.operation.id}/?company_id=${this.compan.id}`
            await axios.get(url).then(res => {
                this.operationslevelones = res.data
            })
        },
        async removeOperationsLevelOne(operationslevelone) {
            const id = operationslevelone.id
            await axios.delete(`${baseApiUrl}/operationslevelones/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadOperationsLevelOnes()
                })
                .catch(showError)
        },
        loadOperationsLevelOne(operationslevelone) {
            this.operationslevelone = { ...operationslevelone }
        },
        setOperations(operation) {
            this.operationslevelone = {}
            this.operationsleveltwo = {}
            this.operationsleveltwos = []
            this.operationstypegroupcostrecipes = []
            this.operation = { ...operation }
            this.loadOperationsLevelOnes()
            this.showTable = true
        },
        async loadOperations() {
            const url = `${baseApiUrl}/operations`
           await axios.get(url).then(res => {
                    this.operations = res.data
                })
        },
       async saveOperationOne() {
            const method = this.operationslevelone.id ? 'put' : 'post'
            const id = this.operationslevelone.id ? `/${this.operationslevelone.id}` : ''
            if(this.operation.id){
                this.operationslevelone.operation_id = this.operation.id
                this.operationslevelone.user_id = this.user.id
            }
            this.operationslevelone.company_id = this.compan.id
           await axios[method](`${baseApiUrl}/operationslevelones${id}`, this.operationslevelone)
            .then(() => {
                this.$toasted.global.defaultSuccess()
                this.operationslevelone = {}
                this.loadOperationsLevelOnes()
            })
            .catch(showError)
        },  

    },
    mounted() {
       this.loadOperations()
    }
}
</script>

<style>

    .operationslevelone{
        font-size: 0.7rem;
        color: white;
    }

     .operationslevelone h3{
        font-size: 0.8rem;
         color: white;
    }

    .operationslevelone h5{
         color: white;
    }

     .operationslevelone h6{
         color: white;
    }


    .operationslevelone input{
        font-size: 0.7rem;
    }

   .operationslevelone button{
        font-size: 0.9rem;
    }

    .operationslevelone select{
        font-size: 0.7rem;
    }

    .operationslevelone form,label,table{
        font-size: 0.7rem;
        color: white;
    }

    #modalOperationOne {
        font-size: 0.7rem;
         color: black;
    }

   #modalOperationOne label {
        font-size: 0.7rem;
         color: black;
    }

    #modalOperationOne input{
        font-size: 0.7rem;
    }

    #modalOperationOne button{
        font-size: 0.7rem;
    }

    #modalOperationOne select{
        font-size: 0.7rem;
    }


    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
}

</style>
